import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import CDS from "design-system";
import BulkScheduleContent from "./BulkScheduleContent";

interface BulkScheduleViewProps {
  journeyId: string;
  timezone: string;
  isOpen: boolean;
  onClose: () => void;
}

export default function BulkScheduleView({ journeyId, timezone, isOpen, onClose }: BulkScheduleViewProps) {
  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent maxW="700px">
        <ModalHeader>
          <CDS.Text16 fontWeight="bold">
            Schedule All Meetings
          </CDS.Text16>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={4}>
          <BulkScheduleContent journeyId={journeyId} timezone={timezone} onComplete={onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
